import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Collapsable } from 'shared/components';
import ResultRow from './ResultRow';
import DetailsTable from './DetailsTable';
import { ConversieButtons } from 'shared/conversie';
import { shapeResult, whiteListUrlParams } from '../config';
import { sync } from 'shared/wizard/actions';
import { getParamsFromState } from 'shared/helpers';

const ResultBlock = ({ result, isActive, hideRadioCheck }) => {
  const dispatch = useDispatch();
  const { app, input, settings } = useSelector(state => state);
  return (
    <>
      <ResultRow
        data={result}
        isActive={isActive}
        setActive={() => sync(dispatch)('label_id', result.label_id)}
        hideProvider={settings.hideProvidersInResult}
        hideRadioCheck={hideRadioCheck}
      />
      {isActive && (
        <>
          {result.rate_corrections.length > 0 && (
            <Collapsable title="Maandlasten overzicht" css={{ margin: '24px 0' }}>
              <div css={{ overflowY: 'auto' }}>
                <DetailsTable result={result} />
              </div>
            </Collapsable>
          )}
          <ConversieButtons
            app={app}
            settings={settings}
            css={{ margin: '24px 0 40px' }}
            urlLeadFormParams={getParamsFromState({ ...input, label_name: result.label_name }, whiteListUrlParams)}
          />
        </>
      )}
    </>
  )   
};

ResultBlock.propTypes = {
  result: shapeResult.isRequired,
  isActive: PropTypes.bool.isRequired,
  hideRadioCheck: PropTypes.bool,
};

ResultBlock.defaultProps = {
  hideRadioCheck: false,
}

export default ResultBlock;
